<template>
    <div class="d-flex w-100 align-items-end" style="z-index: 10;">
        <div class="col-md-12 text-right">
            <span
                class="font-weight-600 color-6"
                :class="isDeleteDisabled ? 'disabled-delete' : 'pointer'"
                @click="deleteEvent"
                v-if="!isCreatingSingleEvent">
                Delete
            </span>
            <button class="btn tertiary px-5" :disabled="getIsUpdatingEvent" @click="cancelEdit">Cancel</button>
            <button class="btn success px-5" :disabled="saveDisabled" @click="saveChanges(false)">Save</button><button v-if="isCreatingSingleEvent" class="btn success px-5" :disabled="saveDisabled" @click="saveChanges(true)">Save & Book</button>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { eventHub } from '../../../main'
    import { getEventEditChannel } from '@/utils/eventEditChannel'


    export default {
        mixins: [],
        props: {
            validations: {
                type: Object
            },
            hasSameEventUpdatedOnAnotherTab: {
                type: Boolean,
                default: false
            },
            hasEventChangedOnOtherTab: {
                type: Boolean,
                default: false
            },
            isloadingEvent: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isCreatingEvent: false,
                emailTypeSelection: null
            }
        },
		created() {
            this.eventHub.$on('email-selection', (value) => {
				this.emailTypeSelection = value;
			})
		},
		beforeDestroy() {
            this.eventHub.$off('email-selection');
		},
        computed: {
            ...mapGetters([
                'getSelectedEvent',
                'account',
                'isCreatingSingleEvent',
                'getIsUpdatingEvent',
                'getBasePrices'
            ]),
            ...mapGetters('eventFormState', [
                'hasPriceErrors',
                'hasPriceGroupErrors',
                'hasDetailsErrors',
                'hasResourceErrors'
            ]),
            hasPriceGroupDecompositionError() {
                const selectedEventId = this.getSelectedEvent;

                if (!selectedEventId || !selectedEventId.passengerSettings || !selectedEventId.passengerSettings.configurations || !selectedEventId.eventGenderPrices) {
                    return false;
                }

                for (const groupPrice of selectedEventId.passengerSettings.configurations) {
                    for (const priceConfig of selectedEventId.eventGenderPrices) {

                        const grossPrices = priceConfig.productGenderPriceComponents.map(service => {
                            if (!service.isRemainingValue && service.component.selectedPrice != null) {
                                return parseFloat(service.component.selectedPrice.grossprice);
                            }
                            return 0;
                        });

                        const sumGrossPrices = grossPrices.reduce((total, price) => total + price, 0);

                        const hasError = priceConfig.productGenderPriceComponents.some(priceComponent => (
                            priceComponent.isRemainingValue && (groupPrice.price - sumGrossPrices < 0.1)
                        ));

                        if (hasError) return true;
                    }
                }

                return false;
            },
            hasPricePerGroupErrors() {
                if (!this.getSelectedEvent || !this.getSelectedEvent.passengerSettings || !this.getSelectedEvent.passengerSettings.configurations) {
                    return false;
                }

                let maxLimit = Infinity;

                switch (this.getSelectedEvent.availabilityType) {
                    case 0:
                        maxLimit = this.getSelectedEvent.maximumLotation || Infinity;
                        break;
                    case 2:
                        if (Array.isArray(this.getSelectedEvent.eventResources)) {
                            maxLimit = this.getSelectedEvent.eventResources.reduce((acc, r) => acc + (r.maxSeats || 0), 0);
                        }
                        break;
                }

                return this.getSelectedEvent.passengerSettings.configurations.some(config =>
                    config.lowerBound > maxLimit || config.upperBound > maxLimit
                );
            }
            ,
            isDeleteDisabled() {
                return this.hasSameEventUpdatedOnAnotherTab || this.isloadingEvent;
            },
            saveDisabled() {
                const noChanges = !this.hasEventChangedOnOtherTab && !this.emailTypeSelection;
                
                return this.validations.$invalid 
                    || this.getIsUpdatingEvent 
                    || this.isCreatingEvent 
                    || this.hasPriceErrors 
                    || this.hasResourceErrors 
                    || this.hasSameEventUpdatedOnAnotherTab 
                    || this.isloadingEvent 
                    || noChanges;
            }
        },
        methods: {
            ...mapActions([
                'saveEventChanges',
                'closeModal',
                'setModalConfirmData',
                'openModal',
                'flushEvents',
                'setReservationSelectedEvent',
                'setReservationSelectedProduct',
                'downloadSingleEvent',
                'updateSelectedEvent',
                'clearUpdateFlags',
                'downloadGenderPricePerChannel',
                'eventNotify',
                'setAsNotCreatingSingleEvent'
            ]),
            updateCalendarAndCloseModal(dateToUpdate) {
                if (this.isCreatingSingleEvent) {
                    this.setAsNotCreatingSingleEvent();
                }
                this.closeModal();
                eventHub.$emit('updateCalendar', dateToUpdate);
            },
            async handleSaveAndBook(eventId, dateToUpdate) {
                try {
                    const response = await axios.get('api/calendar/event', {
                        params: {
                            eventId
                        }
                    });

                    if (response.status === 200 && response.data) {
                        this.setReservationSelectedEvent(response.data);
                        this.setReservationSelectedProduct(response.data.product);
                        await this.$router.push('/reservation/resume');
                    } else {
                        this.$toasted.error('An error occurred while getting new event data. Please try again!');
                    }
                } catch (error) {
                    this.$toasted.error('An error occurred while getting new event data. Please try again!');
                } finally {
                    this.updateCalendarAndCloseModal(dateToUpdate);
                }
            },
            async saveChanges(saveAndBook) {
                if (this.hasDetailsErrors) {
                    return this.$toasted.error('Please review the required fields.');
                }

                if (this.hasPriceGroupErrors || this.hasPricePerGroupErrors || this.hasPriceGroupDecompositionError) {
                    return this.$toasted.error('Please validate Price Groups.');
                }
                
                if (this.hasResourceErrors) {
                    return this.$toasted.error('Please validate Resources.');
                }

                if (this.hasPriceErrors ) {
                    return this.$toasted.error('Please validate Prices.');
                }

                if (!this.isCreatingSingleEvent) {
                    // Is updating existing event
                    if (this.getSelectedEvent.setToCancel) {
                        let vm = this;
                        let message = '<strong>'+this.getSelectedEvent.product.name+'</strong> status will be set as <span class="color-6">canceled</span>.<br>Future bookings will be blocked for this event.';
                        this.$dialog.confirm(message)

                        .then(function () {
                            vm.submitToApiUpdate();
                            vm.closeModal();
                        })
                        .catch(function () {});
                    } else {
                        this.submitToApiUpdate();
                    }
                } else {
                    // Is creating new single event
                    if (this.getSelectedEvent.product == null) {
                        let vm = this;
                        let message = 'In order to create the event you must selected a product on "Date / Location".';
                        
                        this.$dialog.alert(message)
                        .then(function () {
                            return false;
                        })
                    } else {
                        this.isCreatingEvent = true;
                        try {
                            const response = await axios.post('/api/event/create', {
                                supplierId: this.account.supplierId,
                                productId: this.getSelectedEvent.product.id,
                                event: this.getSelectedEvent
                            });

                            if (
                                response.status === 200 &&
                                response.data &&
                                response.data.model &&
                                response.data.model.start &&
                                response.data.model.id
                            ) {
                                const dateToUpdate = response.data.model.start.split(" ")[0];
                                const eventId = response.data.model.id;

                                if (saveAndBook) {
                                    await this.handleSaveAndBook(eventId, dateToUpdate);
                                } else {
                                    this.updateCalendarAndCloseModal(dateToUpdate);
                                }
                            } else {
                                this.$toasted.error('An error occurred while creating event. Please try again!');
                            }
                        } catch (error) {
                            this.$toasted.error('An error occurred while creating event. Please try again!');
                        } finally {
                            this.isCreatingEvent = false;
                        }
                    }
                }
            },
            submitToApiUpdate() {
                let data = {
                    supplierId: this.account.supplierId,
                }
                
                this.saveEventChanges(data).then( response => {
                    // Remove the edited event from calendar (in case for example the durantion changes)
                    const selectedEventId = this.getSelectedEvent.id;
                    this.downloadSingleEvent(selectedEventId).then(response => {
                        const freshEvent = response && response.data ? response.data : null;
                        const eventId = freshEvent ? freshEvent.id : null;

                        // After save event, if exist, send notification
                        if (this.emailTypeSelection) {
                            const payload = {
                                emailType: this.emailTypeSelection,
                                eventId: eventId
                            }

                            this.eventNotify(payload);
                        }

                        if (eventId) {
                            this.updateSelectedEvent(eventId);
                            this.downloadGenderPricePerChannel(eventId);
                        }

                        // Request calendar to refresh
                        this.eventHub.$emit('updateCalendar');

                        const broadcastChannel = getEventEditChannel();
                        if (broadcastChannel && freshEvent) {
                                broadcastChannel.postMessage({ id: freshEvent.id, event: freshEvent });
                        }
                    })

                    this.$toasted.info('Updating calendar to show recent changes');

                    // After updating event clear all updateEventFlags from store(calerndarModule)
                    this.clearUpdateFlags();
                        if (this.$route && this.$route.name === 'calendarExpandedWithEventIdEdit') {
                            const { currentView, expandedDay, eventID } = this.$route.params;
                            this.$router.push({
                                name: 'calendarExpandedWithEventId',
                                params: {
                                    currentView: currentView,
                                    expandedDay: expandedDay,
                                    eventID: eventID
                                }
                            });
                        }

                        this.closeModal();
                });
            },
            deleteEvent() {
                if (this.getIsUpdatingEvent || this.isDeleteDisabled) {
                    return;
                }

                let vm = this;
                let message = 'Delete this event will remove all content related with it<br>(reservations, details and reports data). <br>This can not be undone.';
                
                this.$dialog.confirm(message)
                .then(function () {
                    axios.post('/api/calendar/deleteEvent', {
                        supplierId: vm.account.supplierId,
                        event: vm.getSelectedEvent,
                    }).then(function(response){
                        if (response.status === 200) {
                            vm.flushEvents();
                            let dateToUpdate = vm.getSelectedEvent.start.split(" ")[0];
                            eventHub.$emit('updateCalendar', dateToUpdate);
                            vm.eventHub.$emit('closeCalendarEventDetails');
                            vm.closeModal();
                        }
                    }).catch(() => {})
                })
                .catch(() => {});
            },
            cancelEdit() {
                this.$emit('cancelEdit');
            }
        }
    }
</script>

<style lang="scss" scoped>
.disabled-delete {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// footerButtons.vue?4d4f993c